export const countryNames = {
  AU: 'country.name.australia',
  CA: 'country.name.canada',
  IN: 'country.name.india',
  IE: 'country.name.ireland',
  NZ: 'country.name.new-zealand',
  GB: 'country.name.united-kingdom',
  US: 'country.name.united-states',
  PR: 'country.name.puerto-rico'
} as const
